const TONES = Object.freeze({
  pending: 'warning',
  partial: 'warning',
  missing_payment: 'warning',
  failed: 'danger',
  failed_payment: 'danger',
  divergent: 'danger',
  provider_status_mismatch: 'danger',
  overpaid: 'danger',
  refund_due: 'warning',
  refunded_open_hold: 'danger',
  confirmed: 'positive',
  captured: 'positive',
  reconciled: 'positive',
  refunded: 'neutral',
  not_required: 'neutral',
});

const REASON_KEYS = Object.freeze({
  missing_payment: 'MISSING_PAYMENT',
  partial_payment: 'PARTIAL_PAYMENT',
  overpaid: 'OVERPAID',
  provider_status_mismatch: 'PROVIDER_STATUS_MISMATCH',
  currency_mismatch: 'CURRENCY_MISMATCH',
  refund_due: 'REFUND_DUE',
  refunded_open_hold: 'REFUNDED_OPEN_HOLD',
  failed_payment: 'FAILED_PAYMENT',
});

export const paymentLedgerFor = hold =>
  hold?.payment_ledger || hold?.paymentLedger || null;

export const financialStatusTone = status =>
  TONES[String(status || '').toLowerCase()] || 'neutral';

export const reconciliationTone = status =>
  TONES[String(status || '').toLowerCase()] || 'neutral';

export const divergenceReasonKey = reason =>
  REASON_KEYS[String(reason || '').toLowerCase()] || 'UNKNOWN';

export const hasRefundableBalance = hold => {
  const ledger = paymentLedgerFor(hold);
  return Number(ledger?.actions?.refund_amount || 0) > 0;
};

export const firstRefundableIntent = hold => {
  const ledger = paymentLedgerFor(hold);
  return (ledger?.payment_intents || []).find(
    intent => Number(intent.balance || 0) > 0
  );
};

export const compactLedgerEvents = hold => {
  const ledger = paymentLedgerFor(hold);
  return (ledger?.events || []).map(event => ({
    ...event,
    tone: financialStatusTone(event.status || event.kind),
  }));
};

export default {
  paymentLedgerFor,
  financialStatusTone,
  reconciliationTone,
  divergenceReasonKey,
  hasRefundableBalance,
  firstRefundableIntent,
  compactLedgerEvents,
};
